<!--
  In view mode every field is read-only, so its container has no hover background and no
  interactive border to animate. Suppressing the colour transition keeps a field that renders
  before it knows it is read-only from fading its outline away, which reads as a flicker when the
  drawer swaps between Sends. Scoped here rather than in the component library so interactive
  fields elsewhere keep their transition.
-->
<form
  [id]="formId()"
  [formGroup]="sendFormService.sendForm()"
  [bitSubmit]="submit"
  [class]="editing() ? '' : '[&_[bitfieldcontainer]]:!tw-transition-none'"
>
  @if (!loading) {
    @if (!sendDisabled() && !editing()) {
      <bit-card>
        <div bitTypography="h4">{{ "sendLink" | i18n }}</div>
        <div
          class="tw-text-muted tw-mt-2 tw-mb-4 tw-truncate"
          bitTypography="body2"
          aria-hidden="true"
        >
          {{ sendLink() }}
        </div>
        <button
          class="tw-w-full"
          bitButton
          type="button"
          showToast
          buttonType="primary"
          startIcon="bwi-clone"
          [appCopyClick]="sendLink()"
          [valueLabel]="'sendLink' | i18n"
        >
          {{ "copy" | i18n }}
        </button>
      </bit-card>
    }
    <tools-send-details
      [editing]="editing()"
      (openPasswordGenerator)="openPasswordGenerator.emit()"
    ></tools-send-details>
  }
</form>
